module.exports = __webpack_public_path__ + "static/media/solution-tube-a-plus-closed.93b49c2a.svg";